import { Box, Text, useColorModeValue, type BoxProps } from "@chakra-ui/react";
import { CollecticonCircleExclamation } from "@devseed-ui/collecticons-chakra";

type Props = {
  iconSize?: number;
} & BoxProps;

function Error ({ children, color, iconSize = 8, ...props }: Props) {
  const errorColor = useColorModeValue("red.700", "red.300");
  return (
    <Box textAlign="center" fontWeight="semibold" color={color || errorColor} {...props}>
      <CollecticonCircleExclamation size={iconSize} mb="2" />
      <Text>{ children }</Text>
    </Box>
  );
}

export default Error;
